import moment from "moment";
import { APIResource, APIError, APIResponse } from "../utils/APIResource";

export default class CompanyService {
  static validateIncorporationDate(quoteId, uen, incorporationDate) {
    return APIResource.get(`/v1/quote/${quoteId}/company/validate/incdate/${incorporationDate}?uen=${uen}`)
      .then(resp => {
        return Promise.resolve(new APIResponse(resp));
      })
      .catch(error => {
        return Promise.reject(new APIError(error));
      });
  }

  static getCompanyDetail(quoteId) {
    return APIResource.get(`/v1/quote/${quoteId}/company`)
      .then(resp => {
        return Promise.resolve(new APIResponse(resp));
      })
      .catch(error => {
        return Promise.reject(new APIError(error));
      });
  }

  static putCompanyDetail({ quoteId, details }) {
    const payload = { ...details };
    const { incorporation_date } = payload;
    if (incorporation_date != null && `${incorporation_date}`.trim() !== "") {
      const date = moment(Number.isFinite(Number(incorporation_date)) ? Number(incorporation_date) : incorporation_date);
      if (date.isValid()) {
        // Match the date picker's local calendar date, without converting to UTC.
        payload.incorporation_date = date.format("YYYY-MM-DD");
      }
    }

    return APIResource.put(`/v1/quote/${quoteId}/company`, payload)
      .then(resp => {
        return Promise.resolve(new APIResponse(resp));
      })
      .catch(error => {
        return Promise.reject(new APIError(error));
      });
  }

  static postCompanyDetail({ quoteId, details }) {
    return APIResource.post(`/v1/quote/${quoteId}/company`, details)
      .then(resp => {
        return Promise.resolve(new APIResponse(resp));
      })
      .catch(error => {
        return Promise.reject(new APIError(error));
      });
  }
}
